import DropZoneLogo from "./DropZoneLogo";

export default DropZoneLogo;
